// extracted by mini-css-extract-plugin
module.exports = {"progress":"progress--3U-pB","wave":"wave--3UTNo","menu":"menu--3O5Z6"};
    if(module.hot) {
      // 1637785525160
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  